import { FC } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router";
import { FormInput } from "./ui/Form/FormInput";
import Button from "./ui/Button";

interface SearchFormData {
  search: string;
}

interface MobileSearchBarProps {
  className?: string;
  placeholder?: string;
}

const MobileSearchBar: FC<MobileSearchBarProps> = ({
  className = "",
  placeholder = "Поиск",
}) => {
  const [searchParams] = useSearchParams();
  const { register, handleSubmit } = useForm<SearchFormData>();

  const onSubmit = (data: SearchFormData) => {
    if (data.search.trim()) {
      window.location.href = `/search?search=${encodeURIComponent(
        data.search.trim()
      )}`;
    }
  };

  return (
    <div className={`flex flex-1 items-center gap-4 ${className}`}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-1 rounded-[12px]"
        style={{
          boxShadow: "0 2px 20px rgba(0, 0, 0, 0.1)",
          WebkitBoxShadow: "0 2px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <FormInput
          {...register("search")}
          placeholder={placeholder}
          className="rounded-r-none w-full h-[45px] !px-[15px] flex-1 border-none appearance-none !shadow-none"
          classNameForm="w-full"
          defaultValue={searchParams.get("search") || ""}
        />
        <Button
          style="primary"
          type="submit"
          className="!rounded-l-none !rounded-[12px] !border-[1px] h-[44px] !border-white flex-shrink-0 appearance-none !shadow-none"
        >
          Найти
        </Button>
      </form>
    </div>
  );
};

export default MobileSearchBar;
